import React from 'react';
import ReactDOM from 'react-dom/client';
import {installDashApiFetchGuard} from './session/installDashApiFetchGuard';
import {UserProvider} from "./firebase/UserProvider";
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import './styles/global.css';
import 'ol/ol.css';
import ClaimDetailsDialogHost from './components/prosemirror-editor/components/marginRail/ClaimDetailsDialogHost';
import {EntityDisplayConfigBootstrap} from './hooks/entityDisplayConfig';
import Shell from './Shell';

const root = ReactDOM.createRoot(document.getElementById('root'));

installDashApiFetchGuard();

// Prevent the browser from navigating to a dropped file anywhere in the app.
// Individual drop zones (Sources panel, whiteboard, etc.) call preventDefault in
// their own dragover handlers; this global guard catches everything else so an
// accidental file drop outside a drop zone never replaces the SPA with the raw file.
window.addEventListener('dragover', (e) => { e.preventDefault(); }, false);
window.addEventListener('drop', (e) => { e.preventDefault(); }, false);

root.render(
    <UserProvider>
        <ThemeProvider theme={theme}>
            <CssBaseline/>
            <EntityDisplayConfigBootstrap/>
            <Shell/>
            <ClaimDetailsDialogHost/>
        </ThemeProvider>
    </UserProvider>
);
